import { useEffect, useState } from "react";

function Header() {
  const [username, setUsername] = useState("User");

  useEffect(() => {
    const storedUsername =
      localStorage.getItem("userName") ||
      localStorage.getItem("username") ||
      "User";

    setUsername(storedUsername);
  }, []);

  return (
    <div className="mb-4 flex h-10 items-center justify-end">
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1A5EF9]/10 text-sm font-semibold text-[#1A5EF9]">
          {username.charAt(0).toUpperCase()}
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-800">{username}</p>
          {/* <p className="text-xs text-slate-500">Welcome back</p> */}
        </div>
      </div>
    </div>
  );
}

export default Header;
